import config from 'baseConfig/pg/v2/disputes';
import {
  ACTION_REQUIRED,
  UNDER_REVIEW,
  CLOSED,
  ALL_DISPUTES,
} from 'baseConfig/pg/v2/constants';

export default {
  [ACTION_REQUIRED]: {
    TABLE_COLUMNS: [...config[ACTION_REQUIRED].TABLE_COLUMNS],
    FILTER_ITEMS: { ...config[ACTION_REQUIRED].FILTER_ITEMS },
    SEARCH_ITEMS: [...config[ACTION_REQUIRED].SEARCH_ITEMS],
  },
  [UNDER_REVIEW]: {
    TABLE_COLUMNS: [...config[UNDER_REVIEW].TABLE_COLUMNS],
    FILTER_ITEMS: { ...config[UNDER_REVIEW].FILTER_ITEMS },
    SEARCH_ITEMS: [...config[UNDER_REVIEW].SEARCH_ITEMS],
  },
  [CLOSED]: {
    TABLE_COLUMNS: [...config[CLOSED].TABLE_COLUMNS],
    FILTER_ITEMS: { ...config[CLOSED].FILTER_ITEMS },
    SEARCH_ITEMS: [...config[CLOSED].SEARCH_ITEMS],
  },
  [ALL_DISPUTES]: {
    TABLE_COLUMNS: [...config[ALL_DISPUTES].TABLE_COLUMNS],
    FILTER_ITEMS: { ...config[ALL_DISPUTES].FILTER_ITEMS },
    SEARCH_ITEMS: [...config[ALL_DISPUTES].SEARCH_ITEMS],
  },
};
